package one.healthium.domain.user.models

enum class Gender(val key: String) {
    Female("0"),
    Male("1");

    // TODO loco
    fun displayValue(): String {
        return when (this) {
            Female -> "women"
            Male -> "men"
        }
    }

    companion object {
        fun fromKey(key: String?) = entries.firstOrNull { it.key == key } ?: Female
    }
}